import { render } from "./MobileFilterHeaderMenu.vue?vue&type=template&id=0648b762&ts=true"
import script from "./MobileFilterHeaderMenu.vue?vue&type=script&lang=ts"
export * from "./MobileFilterHeaderMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__